<style>.z-open-hours-component {
    display: flex;
    flex-wrap: wrap;
}
.z-open-daynum {
    width: 100%;
    margin-bottom: 1em;
    position:relative;
}
.z-open-hours-component.columns .z-open-daynum {
    width: auto;
    min-width: calc(25% - 30px);
    margin-right: 30px;

}
.z-open-dayname {
    width: 80px;
    font-size: .8em;
    text-transform: uppercase;
}
.z-open-hours-component.highlight .z-open-daynum.today {
    color:#333;
    padding: 4px 9px;
    margin: -5px 40px 1em -10px !important;
    border: solid 1px #eee;
    border-radius: 10px;
    background: #f5f5f5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .15),
        0 3px 9px rgba(0, 0, 0, .1),
        0 9px 27px rgba(0, 0, 0, .05);
}
.z-open-hours-component.highlight .z-open-daynum.today:before{
    content:'';
    position:absolute;
    right:-20px; top:-10px;
    width: 50px;
    height:0;
    border:solid 15px transparent;
    border-bottom-color:rgba(0,0,0,.5);
    transform:rotate(45deg);

}
.z-open-hours-component.highlight .z-open-daynum.today:after{
    content: 'IDAG';
    display:block;
    color:white;
    transform:rotate(45deg);
    position:absolute;
    line-height:12px;
    right:-3px;
    top:5px;
    font-size: 9px;
    font-weight:bold;
}</style>
<template><div class="z-open-hours-component" :class="{columns : multicol, highlight : showtoday}">
    <div class="z-open-daynum day-1" :class="{today : isToday(1)}" v-if="day1">
        <div class="z-open-dayname">Måndag</div>
        <div class="z-open-hours">{{day1}}</div>
    </div>
    <div class="z-open-daynum day-2" :class="{today : isToday(2)}" v-if="day2">
        <div class="z-open-dayname">Tisdag</div>
        <div class="z-open-hours">{{day2}}</div>
    </div>
    <div class="z-open-daynum day-3" :class="{today : isToday(3)}" v-if="day3">
        <div class="z-open-dayname">Onsdag</div>
        <div class="z-open-hours">{{day3}}</div>
    </div>
    <div class="z-open-daynum day-4" :class="{today : isToday(4)}" v-if="day4">
        <div class="z-open-dayname">Torsdag</div>
        <div class="z-open-hours">{{day4}}</div>
    </div>
    <div class="z-open-daynum day-5" :class="{today : isToday(5)}" v-if="day5">
        <div class="z-open-dayname">Fredag</div>
        <div class="z-open-hours">{{day5}}</div>
    </div>
    <div class="z-open-daynum day-6" :class="{today : isToday(6)}" v-if="day6">
        <div class="z-open-dayname">Lördag</div>
        <div class="z-open-hours">{{day6}}</div>
    </div>
    <div class="z-open-daynum day-7" :class="{today : isToday(7)}" v-if="day7">
        <div class="z-open-dayname">Söndag</div>
        <div class="z-open-hours">{{day7}}</div>
    </div>
</div></template>
<script>export default {
    props: {
        multicol: {
            title: 'Flera kolumner',
            type: Boolean,
            default: false
        },
        showtoday: {
            title: 'Markera idag',
            type: Boolean,
            default: true
        },
        day1: {
            title: 'Måndag',
            type: String,
            default: '08:00 - 17:00'
        },
        day2: {
            title: 'Tisdag',
            type: String,
            default: '08:00 - 17:00'
        },
        day3: {
            title: 'Onsdag',
            type: String,
            default: '08:00 - 17:00'
        },
        day4: {
            title: 'Torsdag',
            type: String,
            default: '08:00 - 17:00'
        },
        day5: {
            title: 'Fredag',
            type: String,
            default: '08:00 - 17:00'
        },
        day6: {
            title: 'Lördag',
            type: String,
            default: 'Stängt'
        },
        day7: {
            title: 'Söndag',
            type: String,
            default: 'Stängt'
        }
    },
    data: () => ({
        count: 1
    }),
    methods: {
        isToday(daynum) {
            daynum = daynum == 0 ? daynum = 6 : daynum--;
            let today = new Date();
            let todaynum = today.getDay();
            return daynum == todaynum;
        }
    }
}</script>